/*
 * This file is part of OsmInEdit, released under ISC license (see LICENSE.md)
 *
 * Copyright (c) Adrien Pavie 2019
 * Copyright (c) Daimler AG 2019
 *
 * Permission to use, copy, modify, and/or distribute this software for any purpose with or without fee is hereby granted, provided that the above copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 */

import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import I18n from '../../config/locales/ui';
import Modal from 'react-bootstrap/Modal';

/**
 * Complete floor imagery dialog asks user to set level information before leaving the floor imagery mode.
 */
class CompleteFloorImageryDialog extends Component {
	render() {
		return <Modal show={this.props.show} onHide={this.props.onClose} size="lg">
			<Modal.Header closeButton>
				<Modal.Title>{I18n.t("Add level information")}</Modal.Title>
			</Modal.Header>
			<Modal.Body>{I18n.t("To make your floor plans appear correctly when editing indoors, please make sure you set on which level they should show up on the left panel.")}</Modal.Body>
			<Modal.Footer>
				<Button variant="secondary" onClick={this.props.onClose}>
					{I18n.t("OK")}
				</Button>
			</Modal.Footer>
		</Modal>;
	}
}

export default CompleteFloorImageryDialog;
